import { render, staticRenderFns } from "./profile-settings.vue?vue&type=template&id=2ab12fa5&scoped=true&"
import script from "./profile-settings.vue?vue&type=script&lang=js&"
export * from "./profile-settings.vue?vue&type=script&lang=js&"
import style0 from "./profile-settings.vue?vue&type=style&index=0&id=2ab12fa5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab12fa5",
  null
  
)

export default component.exports